document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".component_our_team .item")
    .forEach(function (item) {
      item.addEventListener("click", function (e) {
        e.stopPropagation();
        item.classList.add("active");
        document.body.classList.add("popup_active");
        const popupSection = item.querySelector(".team_popup");
        if (popupSection) popupSection.classList.add("active");
      });
    });

  const removeActiveClasses = () => {
    document.querySelectorAll(".team_popup").forEach(function (popup) {
      popup.classList.add("sliding");
      setTimeout(() => {
        popup.classList.remove("active", "sliding");
      }, 500);
    });

    document
      .querySelectorAll(".component_our_team .item")
      .forEach(function (item) {
        setTimeout(() => {
          item.classList.remove("active");
        }, 500);
      });

    setTimeout(() => {
      document.body.classList.remove("popup_active");
    }, 500);
  };

  document.addEventListener("click", function () {
    removeActiveClasses();
  });
  document
    .querySelectorAll(".close_button_popup")
    .forEach(function (closeButton) {
      closeButton.addEventListener("click", function (e) {
        e.stopPropagation();
        removeActiveClasses();
      });
    });

  document.querySelectorAll(".team_popup").forEach(function (popup) {
    popup.addEventListener("click", function (e) {
      e.stopPropagation();
    });
  });
});
